import React, { useState } from 'react';
import { Check, ChevronLeft, ChevronRight } from 'lucide-react';
import { useRevealOnScroll } from '../../hooks/useRevealOnScroll';
const WHATSAPP_URL = 'https://wa.me/77010346443?text=%D1%85%D0%BE%D1%87%D1%83%20%D0%B4%D0%B5%D0%BC%D0%BE%20Meelo';
const features = [{
  label: 'Методика',
  title: 'Методический блок',
  description: 'Вся методическая документация — в порядке и готова к проверке',
  bullets: ['Перспективные планы', 'Циклограммы', 'Конспекты к ООД'],
  image: 'https://cdn.magicpatterns.com/uploads/cSfFjs1QLaFkjpprBaUn8D/журналы.png',
  images: ['https://cdn.magicpatterns.com/uploads/8BE9aBQxMzEdYJY4P1zUS9/Screenshot_2026-02-18_at_23.32.30.png', 'https://cdn.magicpatterns.com/uploads/8XVKzRYhgkqPVgs8v3V9st/Screenshot_2026-02-19_at_11.01.39.png', 'https://cdn.magicpatterns.com/uploads/qxeU4Ka2BGZ9SbhaMdQ8hh/Screenshot_2026-02-19_at_11.02.29.png'],
  type: 'desktop' as const
}, {
  label: 'Питание',
  title: 'Питание и склад',
  description: 'Автоматизация всего процесса — от и до',
  bullets: ['Генерация меню (перспективное меню, техкарты, раскладка)', 'Внедрение вашего меню в систему', 'Автоматический закуп и списание по калькуляции', 'Автоматическое ведение пищевых журналов'],
  image: 'https://cdn.magicpatterns.com/uploads/wGEXkWBfz5D1U5Hv1vr71s/склад.png',
  images: undefined,
  type: 'desktop' as const
}, {
  label: 'Финансы',
  title: 'Финансы и администрация',
  description: 'Прозрачная финансовая картина: от начисления оплаты до расчёта зарплат и контроля задолженности.',
  bullets: ['Автоматический расчёт оплаты', 'Контроль задолженности', 'Расчёт зарплаты и ФОТ', 'Дашборд руководителя'],
  image: 'https://cdn.magicpatterns.com/uploads/oXtJB5vYaQnWngUE2my9vs/скрин_оплаты.png',
  images: undefined,
  type: 'desktop' as const
}, {
  label: 'Родители',
  title: 'Родительский модуль',
  description: 'Удобное приложение для родителей со всей необходимой информацией',
  bullets: ['Лента дня', 'Меню', 'Расписание', 'Обращения в администрацию сада', 'Видеокамеры'],
  image: 'https://cdn.magicpatterns.com/uploads/wVYfLqSbNxSAENx5XfTiKV/мокап_лента_дня.png',
  images: undefined,
  type: 'mobile' as const
}];
const MODULE_NUMBERS = ['02', '03', '04', '05'];
function CtaPair() {
  return <div className="mt-8 flex flex-col sm:flex-row items-start gap-3" data-id="element-157">
      <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-3 rounded-full bg-[#7C4DFF] text-white font-medium text-base shadow-lg hover:bg-[#651FFF] transition-all" data-id="element-158">
        Узнать подробнее
      </a>
      <span className="inline-flex items-center px-5 py-2.5 rounded-full text-sm font-medium text-gray-600 bg-gray-100 border border-gray-200" data-id="element-159">
        20 000 ₸ / в месяц
      </span>
    </div>;
}
function DesktopGallery({
  images,
  title
}: {
  images: string[];
  title: string;
}) {
  const [active, setActive] = useState(0);
  const prev = () => setActive(i => (i - 1 + images.length) % images.length);
  const next = () => setActive(i => (i + 1) % images.length);
  return <div data-id="element-160">
      <div className="rounded-2xl shadow-2xl border border-gray-200 overflow-hidden bg-white group relative" data-id="element-161">
        <div className="h-8 bg-gray-50 border-b border-gray-100 flex items-center px-4 space-x-2" data-id="element-162">
          <div className="w-3 h-3 rounded-full bg-red-400" data-id="element-163" />
          <div className="w-3 h-3 rounded-full bg-yellow-400" data-id="element-164" />
          <div className="w-3 h-3 rounded-full bg-green-400" data-id="element-165" />
        </div>
        <div className="relative" data-id="element-166">
          {images.map((src, i) => <img key={i} src={src} alt={`${title} — экран ${i + 1}`} className="w-full h-auto block" style={{
          position: i === 0 ? 'relative' : 'absolute',
          top: 0,
          left: 0,
          opacity: active === i ? 1 : 0,
          transition: 'opacity 250ms ease',
          pointerEvents: active === i ? 'auto' : 'none'
        }} data-id="element-167" />)}
          <button onClick={prev} aria-label="Предыдущий экран" className="absolute left-2 top-1/2 -translate-y-1/2 z-10 w-8 h-8 rounded-full bg-white/70 border border-gray-200 flex items-center justify-center text-gray-600 opacity-40 hover:opacity-100 transition-opacity md:opacity-0 md:group-hover:opacity-90 shadow-sm" data-id="element-168">
            <ChevronLeft size={16} data-id="element-169" />
          </button>
          <button onClick={next} aria-label="Следующий экран" className="absolute right-2 top-1/2 -translate-y-1/2 z-10 w-8 h-8 rounded-full bg-white/70 border border-gray-200 flex items-center justify-center text-gray-600 opacity-40 hover:opacity-100 transition-opacity md:opacity-0 md:group-hover:opacity-90 shadow-sm" data-id="element-170">
            <ChevronRight size={16} data-id="element-171" />
          </button>
        </div>
      </div>
      <div className="flex justify-center gap-2 mt-3" data-id="element-172">
        {images.map((_, i) => <button key={i} onClick={() => setActive(i)} aria-label={`Экран ${i + 1}`} style={{
        width: 8,
        height: 8,
        borderRadius: '50%',
        border: 'none',
        cursor: 'pointer',
        padding: 0,
        background: active === i ? '#7C4DFF' : '#D1D5DB',
        transition: 'background 200ms ease'
      }} data-id="element-173" />)}
      </div>
    </div>;
}
function FeatureVisual({
  feature
}: {
  feature: (typeof features)[number];
}) {
  if (feature.type === 'mobile') {
    return <div className="rounded-3xl bg-gradient-to-br from-[#F3EEFF] via-[#EDE7F6] to-[#F8F5FF] flex items-center justify-center p-8 lg:p-12 min-h-[420px] lg:min-h-[500px]" data-id="element-174">
        <div className="relative w-full flex items-end justify-center" style={{
        height: 420
      }} data-id="element-175">
          {/* Back phone */}
          <img src="https://cdn.magicpatterns.com/uploads/72Lf8Yrm1xA7wzLU6cnKZw/Mockuuups_Free_Transparent_iPhone_Air_Mockup.png" alt="Трансляция" style={{
          position: 'absolute',
          bottom: 0,
          left: '50%',
          transform: 'translateX(-110%) rotate(-5deg)',
          height: 340,
          width: 'auto',
          objectFit: 'contain',
          opacity: 0.85,
          filter: 'drop-shadow(0 8px 24px rgba(0,0,0,0.12))',
          zIndex: 1
        }} data-id="element-176" />
          {/* Front phone */}
          <img src="https://cdn.magicpatterns.com/uploads/m64wkFNvbCAXCjaTobC78V/Mockuuups_Free_Transparent_iPhone_Air_Mockup.png" alt="Лента дня" style={{
          position: 'absolute',
          bottom: 0,
          left: '50%',
          transform: 'translateX(-30%)',
          height: 400,
          width: 'auto',
          objectFit: 'contain',
          filter: 'drop-shadow(0 16px 40px rgba(124,77,255,0.18))',
          zIndex: 2
        }} data-id="element-177" />
        </div>
      </div>;
  }
  if (feature.images && feature.images.length > 0) {
    return <DesktopGallery images={feature.images} title={feature.title} data-id="element-178" />;
  }
  return <div className="rounded-2xl shadow-2xl border border-gray-200 overflow-hidden bg-white" data-id="element-179">
      <div className="h-8 bg-gray-50 border-b border-gray-100 flex items-center px-4 space-x-2" data-id="element-180">
        <div className="w-3 h-3 rounded-full bg-red-400" data-id="element-181" />
        <div className="w-3 h-3 rounded-full bg-yellow-400" data-id="element-182" />
        <div className="w-3 h-3 rounded-full bg-green-400" data-id="element-183" />
      </div>
      <img src={feature.image} alt={feature.title} className="w-full h-auto" data-id="element-184" />
    </div>;
}
// Wrapper that applies reveal animation to each visual
function RevealVisualWrapper({
  children,
  delay
}: {
  children: React.ReactNode;
  delay: number;
}) {
  const ref = useRevealOnScroll<HTMLDivElement>(delay, 0.15);
  return <div ref={ref} className="reveal-visual visual-hover-lift" data-id="element-185">
      {children}
    </div>;
}
export function SolutionSection() {
  return <section className="pt-6 pb-24 bg-[#FAFAFA]" data-id="element-186">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-187">
        <div className="space-y-6" data-id="element-188">
          {features.map((feature, index) => {
          const isReversed = index % 2 !== 0;
          return <div key={index} className="rounded-3xl border border-gray-100 bg-white shadow-sm overflow-hidden" data-id="element-189">
                {/* Module header bar */}
                <div className="px-6 py-3 border-b border-gray-100 flex items-center gap-3" data-id="element-190">
                  <span className="text-xs font-bold text-gray-300 tracking-widest font-mono" data-id="element-191">
                    {MODULE_NUMBERS[index]} / 05
                  </span>
                  <span className="text-xs font-semibold tracking-widest uppercase text-[#7C4DFF]/70" data-id="element-192">
                    {feature.label}
                  </span>
                </div>

                {/* Module content */}
                <div className="p-6 lg:p-10" data-id="element-193">
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center" data-id="element-194">
                    <div className={isReversed ? 'lg:order-2' : 'lg:order-1'} data-id="element-195">
                      <h3 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#1A1A2E] leading-tight mb-4" data-id="element-196">
                        {feature.title}
                      </h3>
                      <p className="text-gray-600 text-base lg:text-lg leading-relaxed mb-6 max-w-lg" data-id="element-197">
                        {feature.description}
                      </p>
                      <ul className="space-y-3" data-id="element-198">
                        {feature.bullets.map((bullet, idx) => <li key={idx} className="flex items-center gap-3" data-id="element-199">
                            <div className="flex-shrink-0 w-5 h-5 rounded-full bg-green-100 flex items-center justify-center" data-id="element-200">
                              <Check className="w-3 h-3 text-green-600" strokeWidth={3} data-id="element-201" />
                            </div>
                            <span className="text-gray-700 font-medium text-sm lg:text-base" data-id="element-202">
                              {bullet}
                            </span>
                          </li>)}
                      </ul>
                      <CtaPair data-id="element-203" />
                    </div>

                    <div className={isReversed ? 'lg:order-1' : 'lg:order-2'} data-id="element-204">
                      <RevealVisualWrapper delay={index * 60} data-id="element-205">
                        <FeatureVisual feature={feature} data-id="element-206" />
                      </RevealVisualWrapper>
                    </div>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}